export const GET_RESULT = 'GET_RESULT';
export const GET_RESULT_SUCCESS = 'GET_RESULT_SUCCESS';
export const GET_RESULT_FAILURE = 'GET_RESULT_FAILURE';

export const SET_RESULT = 'SET_RESULT';

export const CREATE_RESULT = 'CREATE_RESULT';
export const CREATE_RESULT_SUCCESS = 'CREATE_RESULT_SUCCESS';
export const CREATE_RESULT_FAILURE = 'CREATE_RESULT_FAILURE';

export const GET_RESULT_USER = 'GET_RESULT_USER';
export const GET_RESULT_USER_SUCCESS = 'GET_RESULT_USER_SUCCESS';



// WEBPACK FOOTER //
// ./src/actionTypes/resultActionTypes.js